import {
  Box,
  Input,
  List,
  ListItem,
  VStack,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect, useState } from "react";

const SelectCounteragentPotential = observer(() => {
  const { pageStore } = useStores();
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredAgents = pageStore.all_agents_potential.filter((item) =>
    item?.name?.toLowerCase().includes(pageStore.selected_one_agent_potential.toLowerCase())
  );

  const handleSelect = (value) => {
    pageStore.updateSelectedAgentPotential(value);
    setShowDropdown(false);
  };

  return (
    <VStack align="start" position="relative" width="200px">
      <Input
        placeholder="Контрагенты"
        value={pageStore.selected_one_agent_potential}
        onChange={(e) => {
          pageStore.updateSelectedAgentPotential(e.target.value);
          pageStore.updateSelectedAgentPotential(e.target.value);
          setShowDropdown(true);
        }}
        onFocus={() => setShowDropdown(true)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 150)} 
        bg="#333"
        color="#EEEEEE"
        borderRadius="10px"
        fontWeight="600"
      />

      {showDropdown && filteredAgents.length > 0 && (
        <Box
          position="absolute"
          top="100%"
          width="300px"
          zIndex="1000"
          bg="#1A1A1A"
          borderRadius="md"
          boxShadow="md"
          maxHeight="200px"
          overflowY="auto"
        >
          <List spacing={1}>
            {filteredAgents.map((item, index) => (
              <ListItem
                key={index}
                px={3}
                py={2}
                _hover={{ bg: "#2D2D2D", cursor: "pointer" }}
                color="#EEEEEE"
                onClick={() => handleSelect(item?.name)}
              >
                {item?.name}
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </VStack>
  );
});

export default SelectCounteragentPotential;
